// extracted by mini-css-extract-plugin
export default {"label":"label--g5lHAPbth8UqciSfIjnQ","label--required":"label--required--udhlwV9jYX5hbwvzddQA"};